/* agfi (Ansen 2026-10-16, collection filters). Canvas: https://claude.ai/artifact/UeHrKQFbvtZVJpS75VuUMP
   1. Desktop (992px and up): the sort & filter rail scrolls with the page like normal. Going down, once its last
      filter is on screen it follows with its bottom in view; going up, once its top is back on screen it follows
      with its top in view (board 2). Round 2 (Ansen: "moves really fast, like it clips in and out"): the browser's
      own position: sticky does the moving, so it is as smooth as the page. This script only re-anchors the rail
      when the scroll direction flips: a spacer above it takes the rail's current spot, and the rail then sticks by
      its bottom (going down) or by its top (going up). A rail shorter than the screen simply sticks at the top.
   2. The i beside Width / Length shows the "how we measure" card (#agfi-card, snippets/ag-facet-info.liquid).
      Round 3: the desktop top menu has the same i beside "by Width" / "by Length" (snippets/ag-facet-info-nav.liquid);
      every i opens the card its aria-controls names, and only one card is open at a time.
      With a mouse it shows while the pointer is on the i and goes away when it leaves (round 2); on touch screens
      a tap opens it and a tap outside, its X or Escape closes it. Clicks on the i never fold the filter group.
   3. Once the rail heading has scrolled out of view, a slim "2 filters on · Reset" bar shows at the top of the rail.
   The rail is replaced whenever a filter changes (FacetFiltersForm in sections/collection_products.liquid), so
   everything here looks the elements up again and never keeps a stale one. */
(function () {
  'use strict';
  if (window.agFacetInfo) return;
  var DESK = window.matchMedia('(min-width: 992px)');
  var HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CALM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var GAP = 16;
  var st = { rail: null, spacer: null, mode: null, lastY: window.scrollY, raf: 0, t: 0, open: null };
  var ro = window.ResizeObserver ? new ResizeObserver(function () { schedule(); }) : null;

  function headerBottom() {
    var n = document.querySelector('.section_navbar');
    if (!n) return 0;
    var b = n.getBoundingClientRect().bottom;
    return b > 0 ? b : 0;
  }

  function px(el, prop, v) {
    var s = v === 'auto' ? 'auto' : Math.round(v) + 'px';
    if (el.style[prop] !== s) el.style[prop] = s;
  }

  function release(rail) {
    if (rail) { rail.style.top = ''; rail.style.bottom = ''; }
    if (st.spacer && st.spacer.parentNode) st.spacer.parentNode.removeChild(st.spacer);
    st.rail = null; st.spacer = null; st.mode = null; st.prevTop = null;
  }

  function update() {
    st.raf = 0;
    var wrap = document.getElementById('facets');
    var rail = wrap && wrap.querySelector('.facets-container');
    var y = window.scrollY;
    var dir = y > st.lastY ? 'down' : y < st.lastY ? 'up' : null;
    st.lastY = y;
    if (!rail) return;
    if (!DESK.matches) { release(rail); return; }
    if (rail !== st.rail) {
      if (ro && st.rail) ro.unobserve(st.rail);
      st.rail = rail; st.mode = null; st.prevTop = null;
      st.spacer = document.createElement('div');
      st.spacer.className = 'agfi-spacer';
      st.spacer.setAttribute('aria-hidden', 'true');
      rail.parentNode.insertBefore(st.spacer, rail);
      if (ro) ro.observe(rail);
    }
    var hb = headerBottom();
    var H = window.innerHeight;
    var R = rail.offsetHeight;
    var topIn = hb + GAP;                              // first free pixel under the header (screen)
    if (R <= H - topIn - GAP) {                        // short rail: just stick at the top
      st.spacer.style.height = '0px';
      px(rail, 'top', topIn); px(rail, 'bottom', 'auto');
      st.mode = 'short';
    } else {
      var want = dir || (st.mode === 'up' ? 'up' : 'down');
      if (want !== st.mode) {                          // re-anchor where the rail was, then stick the other way
        var P = wrap.getBoundingClientRect().top + y;   // where the rail rests with no spacer
        // where it stood before this scroll step (the old stick already carried it along by this step)
        var cur = st.prevTop != null ? st.prevTop : rail.getBoundingClientRect().top + y;
        var grid = document.querySelector('.filter_product-list-wrapper');
        var maxM = Math.max(0, (grid ? grid.offsetHeight : wrap.offsetHeight) - R);
        st.spacer.style.height = Math.round(Math.max(0, Math.min(cur - P, maxM))) + 'px';
        st.mode = want;
      }
      if (st.mode === 'down') { px(rail, 'top', H - GAP - R); px(rail, 'bottom', 'auto'); }
      else { px(rail, 'top', 'auto'); px(rail, 'bottom', H - topIn - R); }
    }
    mini(wrap, rail, hb);
    st.prevTop = rail.getBoundingClientRect().top + y;
  }

  function mini(wrap, rail, top) {
    var m = wrap.querySelector('.agfi-mini');
    if (!m) return;
    m.style.setProperty('--agfi-top', Math.round(top) + 'px');
    var head = rail.querySelector('.facet-heading-block');
    var gone = head ? head.getBoundingClientRect().bottom < top + 4 : false;
    m.classList.toggle('is-on', gone);
  }

  function schedule() {
    if (!st.raf) st.raf = window.requestAnimationFrame(update);
  }

  // Each i names its own card (aria-controls): the rail's #agfi-card, or one of the top menu's cards (round 3).
  function cardOf(btn) { return btn ? document.getElementById(btn.getAttribute('aria-controls')) : null; }

  function openBtn() {
    var b = st.open;
    var c = cardOf(b);
    return b && b.isConnected && c && c.classList.contains('is-open') ? b : null;
  }

  // Round 5 (Ansen): in the phone menu the card slides open and shut under its row, like the menu's own lists; when
  // the row's size list is open the card floats over it and fades in and out. Elsewhere the stylesheet fades it.
  function showCard(c, open) {
    var inMenu = c.closest && c.closest('.header_dropdown-mobile-nav');
    if (!inMenu || !c.animate || CALM.matches) { c.classList.toggle('is-open', open); return; }
    if (c.getAnimations) c.getAnimations().forEach(function (a) { a.onfinish = null; a.cancel(); });
    var wasOpen = c.classList.contains('is-open');
    if (open) c.classList.add('is-open');
    else if (!wasOpen) return;
    var cs = window.getComputedStyle(c);
    var a;
    if (cs.position === 'absolute') {
      if (!open) {          // the list under it may shut in the same tap: hold the card where it floats while it fades
        c.style.position = 'absolute'; c.style.top = cs.top; c.style.left = cs.left; c.style.right = cs.right; c.style.margin = '0';
      }
      a = c.animate(open ? [{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'none' }]
        : [{ opacity: 1 }, { opacity: 0 }], { duration: 160, easing: 'ease' });
    } else {
      var full = { height: c.offsetHeight + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom,
        marginBottom: cs.marginBottom, opacity: 1 };
      var none = { height: '0px', paddingTop: '0px', paddingBottom: '0px', marginBottom: '0px', opacity: 0 };
      c.style.overflow = 'hidden';
      a = c.animate(open ? [none, full] : [full, none], { duration: 260, easing: 'ease' });
    }
    a.onfinish = function () {
      c.style.overflow = '';
      c.style.position = c.style.top = c.style.left = c.style.right = c.style.margin = '';
      if (!open) c.classList.remove('is-open');
    };
  }

  function setOpen(btn, open, focusBack) {
    var c = cardOf(btn);
    if (!c) return;
    window.clearTimeout(st.t);
    var cur = openBtn();
    if (open && cur && cur !== btn) setOpen(cur, false, false);
    c.hidden = false;
    showCard(c, open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    st.open = open ? btn : (st.open === btn ? null : st.open);
    if (!open && focusBack) btn.focus();
  }

  // Mouse: the card shows while the pointer is on the i, and goes away a moment after it leaves.
  document.addEventListener('mouseover', function (e) {
    if (!HOVER.matches || !e.target.closest) return;
    var b = e.target.closest('.agfi-btn');
    if (b) setOpen(b, true, false);
  }, true);
  document.addEventListener('mouseout', function (e) {
    if (!HOVER.matches || !e.target.closest) return;
    var b = e.target.closest('.agfi-btn');
    if (!b || (e.relatedTarget && b.contains(e.relatedTarget))) return;
    window.clearTimeout(st.t);
    st.t = window.setTimeout(function () { setOpen(b, false, false); }, 120);
  }, true);
  // Keyboard: focusing the i shows the card, leaving it hides it.
  document.addEventListener('focusin', function (e) {
    var b = e.target.closest && e.target.closest('.agfi-btn');
    if (b && HOVER.matches) setOpen(b, true, false);
  });
  document.addEventListener('focusout', function (e) {
    var b = e.target.closest && e.target.closest('.agfi-btn');
    if (b && HOVER.matches) setOpen(b, false, false);
  });

  // Capture phase, so the rail's own "click a group head to fold it" handler (and the menu's) never sees these clicks.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('.agfi-btn');
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      var c = cardOf(b);
      setOpen(b, HOVER.matches ? true : !(c && c.classList.contains('is-open')), false);
      return;
    }
    var cur = openBtn();
    if (!cur) return;
    var oc = cardOf(cur);
    if (t.closest('.agfi-x')) {
      e.preventDefault();
      e.stopPropagation();
      setOpen(cur, false, true);
      return;
    }
    if (oc.contains(t)) {
      e.stopPropagation();
      return;
    }
    setOpen(cur, false, false);
  }, true);

  document.addEventListener('keydown', function (e) {
    var cur = openBtn();
    if ((e.key === 'Escape' || e.key === 'Esc') && cur) setOpen(cur, false, true);
  });

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  if (DESK.addEventListener) DESK.addEventListener('change', schedule);
  var grid = document.getElementById('filtered-products-container');
  if (grid && window.MutationObserver) new MutationObserver(schedule).observe(grid, { childList: true });
  window.agFacetInfo = { update: update };
  schedule();
})();
